export class LogoutUseCaseImpl {
    constructor(authRepository) {
        this.authRepository = authRepository;
    }
    run() {
        return this.authRepository.logout();
    }
}
